import {firestore} from "../config/firebaseConfig";

export const itemsCollection = firestore.collection("items")

export const TestFunctionCollection = firestore.collection("TestFunction")

export const keywordsCollection = firestore.collection("keyWords");

export const referencesCollection = firestore.collection("reference_stories");

export const shippingCollection = firestore.collection('shipping_orders');

export const receivingCollection = firestore.collection('received_orders');

export const purchaseCollection = firestore.collection('purchase_orders');

export const familyCollection = firestore.collection('family');

export const rolesCollection = firestore.collection('roles');

export const familyReferences = firestore.collection('reference_stories').doc('family')

export const barecodeRef = firestore.collection('reference_stories').doc('lastInternalUPC')
export const cartOrderCollection = firestore.collection("cart_order") 
export const vendors = firestore.collection('vendors')


